const initialState = {
    noData: false,
    searchList: [],
    filter: {},
    filters: {},
    fetching: false,
    fetched: false,
    page: 1,
    pages: 0,
    error: null
}

export function advancedSearchReducer(state = initialState, action) {

    switch (action.type) {
        case "FETCH_ADVANCEDSEARCH_LIST_TOKEN": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "FETCH_ADVANCEDSEARCH_LIST_CLEAR": {
            return { ...state, fetching: false, fetched: true, searchList: [], page: 1, pages: 0, error: null }
        }

        case "FETCH_ADVANCEDSEARCH_LIST": {
            return { ...state, fetching: true, fetched: false, page: action.payload.data.page, error: null }
        }

        case "FETCH_ADVANCEDSEARCH_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }

        case "FETCH_ADVANCEDSEARCH_LIST_FULFILLED": {
            let advancedRecs

            if (state.page === 1)
                advancedRecs = action.payload.data.advancedSearchRecords
            else {
                advancedRecs = Object.assign([], state.searchList)
                action.payload.data.advancedSearchRecords.forEach((rec) => advancedRecs.push(rec))
            }

            advancedRecs.sort((a, b) => {
                if (a.reicoSKU > b.reicoSKU)
                    return 1
                else if (a.reicoSKU < b.reicoSKU)
                    return -1
                else 
                    return 0
            })

            return {
                ...state,
                fetching: false,
                fetched: true,
                noData: advancedRecs.length == 0, 
                filters: {
                    manufacturers: action.payload.data.manufacturers,
                    productLines: action.payload.data.productLines
                },
                pages: action.payload.data.totalRecords,
                searchList: advancedRecs,
            }
        }

        case "FETCH_ADVANCEDSEARCH_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        default:
            return state
    }
}
